/* 提示类型 */
const ALERT_TYPE = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  ERROR: 'error',
  QUESTION: 'question'
}

/* 导入阶段 */
const IMPORT_PHASE = {
  READY: 'READY', // 导入准备阶段
  IMPORT_ING: 'IMPORT_ING', // 正在导入阶段
  IMPORT_DONE: 'IMPORT_DONE' // 导入完成阶段
}

/* 导入校验阶段 */
const VALIDATE_PHASE = {
  READY: 'READY', // 校验准备阶段
  VALIDATE_ING: 'VALIDATE_ING', // 正在校验阶段
  VALIDATE_DONE: 'VALIDATE_DONE' // 校验完成阶段
}

/* 重复操作 */
const REAPEAT_OPER = {
  IGONRE: 0, // 跳过
  UPDATE: 1 // 更新
}

/* 导入操作(更新/跳过) */
const IMPORT_OPER = {
  IGONRE: 0, // 跳过
  UPDATE: 1 // 更新
}

/* 导入列表条件查询 */
const IMPORT_QUERY_TYPE = {
  VALIDATE_SUCCESS: 1, // 校验成功
  VALIDATE_FAIL: 2, // 校验失败
  IMPORT_SUCCESS: 3, // 导入成功
  IMPORT_FAIL: 4 // 导入失败
}

/* 导入列表查询类型 */
const IMPORT_TYPE = {
  REPEAT: 'REPEAT', //  重复
  VALIDATE: 'VALIDATE', // 校验
  IMPORT: 'IMPORT' // 导入
}

/* TABLE值初始化 */
const TABLE_INIT = {
  PAGESIZE: 100000, // TABLE每页的条数(默认10条)
  IMPORT_PAGESIZE: 8, // TABLE每页的条数(导入默认8条)
  PAGENO: 1, // TABLE当前页(默认第1页)
  TOTAL: 0 // TABLE当前的总条数(默认0条)
}

export default {
  ALERT_TYPE,
  IMPORT_PHASE,
  VALIDATE_PHASE,
  REAPEAT_OPER,
  IMPORT_OPER,
  IMPORT_QUERY_TYPE,
  IMPORT_TYPE,
  TABLE_INIT
}
